import React, {useState} from 'react';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, MenuItem, TextField} from '@mui/material';
import * as CommunicationService from '../../../services/CommunicationService';
import * as LogicService from '../../../services/LogicService';

export default function TeregoStartModal({row, lawyers, handleClose, onOrderUpdated}) {
    const [lawyerId, setLawyerId] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const handleStart = async () => {
        if (saving || !lawyerId) return;
        setSaving(true);
        setError('');
        try {
            await CommunicationService.startTeregoOrder(row.id, lawyerId);
        } catch (failure) {
            let message = 'Comanda nu a putut fi pornită. Încercați din nou.';
            try {
                message = JSON.parse(failure.message).message || message;
            } catch (_) { /* Keep the fallback for network errors. */ }
            setError(message);
            setSaving(false);
            return;
        }
        LogicService.setAlertMessageAndSeverity({
            message: 'Comanda este în lucru și avocatul a fost atribuit.', severity: 'success'
        });
        handleClose();
        if (onOrderUpdated) onOrderUpdated();
    };

    return <Dialog open fullWidth maxWidth="sm" onClose={saving ? undefined : handleClose}
                   aria-labelledby="terego-start-title">
        <DialogTitle id="terego-start-title">Începe comanda TEREGO 0 LEI #{row.id}</DialogTitle>
        <DialogContent>
            <DialogContentText sx={{mb: 3}}>
                Comanda va fi trecută în lucru, iar promoția TEREGO va fi marcată ca finalizată manual.
                Avocatul selectat va primi acces la comandă. Prețul rămâne 0 LEI, fără emiterea unei facturi.
            </DialogContentText>
            {error && <Alert severity="error" sx={{mb: 2}}>{error}</Alert>}
            <TextField id="terego-lawyer" select fullWidth label="Avocat" value={lawyerId} disabled={saving}
                       onChange={event => setLawyerId(event.target.value)}
                       helperText={lawyers.length ? 'Selectați avocatul care va prelua comanda.' : 'Nu există avocați disponibili.'}>
                {lawyers.map(lawyer => <MenuItem key={lawyer.id} value={lawyer.id}>
                    {lawyer.name || lawyer.username}
                </MenuItem>)}
            </TextField>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} disabled={saving}>Anulează</Button>
            <Button variant="contained" onClick={handleStart} disabled={saving || !lawyerId}>
                {saving ? 'Se salvează…' : 'În lucru și atribuie avocat'}
            </Button>
        </DialogActions>
    </Dialog>;
}
